<template>
  <div>
    <v-layout row wrap>
      <v-flex xs6 md2 v-for="menu in menus" :key="menu.title" pt-2>
        <v-flex>
          <h4>{{ menu.title }}</h4>
        </v-flex>
        <v-flex v-for="submenu in menu.submenus" :key="submenu.title"><a :href="submenu.link">{{submenu.title}}</a> </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    menus: {
      type: Array,
      required: true
    }
  }
};
</script>